module.exports = __webpack_public_path__ + "img/close-large.73356277.svg";